import Vue from 'vue';
import App from './App.vue';

// vuex
import store from './store';

// vue router
import router from './router';
import vuetify from './plugins/vuetify';

// mixins
import mixinHelper from '@/helpers/mixinHelper';

Vue.config.productionTip = false;

Vue.mixin({
  data() {
    return {
      validation: {
        length10: [
          (v) => !!v || 'Required',
          (v) => (v && v.length <= 10) || 'Must be less than 10 characters'
        ],
        length50: [
          (v) => !!v || 'Required',
          (v) => (v && v.length <= 50) || 'Must be less than 50 characters'
        ],
        length150: [
          (v) => !!v || 'Required',
          (v) => (v && v.length <= 150) || 'Must be less than 150 characters'
        ],
        length250: [
          (v) => !!v || 'Required',
          (v) => (v && v.length <= 250) || 'Must be less than 250 characters'
        ],
        length1000: [
          (v) => (v && v.length <= 1000) || 'Must be less than 1000 characters'
        ],
        length25: [
          (v) => !!v || 'Required',
          (v) => (v && v.length <= 25) || 'Must be less than 25 characters'
        ],
        numeric: [
          (v) => v != null || 'Required',
          (v) => !isNaN(v) || 'Must be numeric'
        ],
        atLeastOne: [
          (v) => !!v || 'Required',
          (v) => (!isNaN(v) && v > 0) || 'Must be at least one'
        ],
        selection: [(v) => !!v || 'Required']
      }
    };
  },
  methods: {
    ...mixinHelper.methods
  }
});

export default new Vue({
  vuetify,
  router,
  store,
  render: (h) => h(App)
}).$mount('#app');
